import axios from "axios";

const publicApiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default publicApiClient;
